import React from "react";
import { bannerImage } from "../../assets/index";
const RightBanner = () => {
  return (
    <div className="w-full lgl:w-1/2 flex justify-center items-center relative">
      <img
        className=" w-full h-auto  z-10 "
        src={bannerImage}
        alt="bannerImg"
      />
       <div className="absolute botton-0  w-[250px]  h-[300px] lgl:w-[350px] lgl:h-[390px] mt-20 bg-grdient-to-r 
       from=[#1e2024] to-[#222327] shadow-shadowOne flex justify-center items-center ">
      
      </div>
    </div>
   
  );
};

export default RightBanner;
